import { CancelSubscriptionDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const cancelSubscriptionCallable = getCallable(
  CancelSubscriptionDefinition
);
